import { swapDates } from "components/dashboard/product-template-table/utils/timeUtils";
import { useState } from "react";
import { addToDate, truncateDate } from "utils/time-utils";
import { timeConfigValidation } from "utils/utils";
import { Instant } from "@js-joda/core";

interface TimeContext {
  referenceTime?: string;

  from?: string;
  to?: string;

  config?: any;
}

const useTimeState = (ctx: TimeContext) => {
  const getDefaultDate = (date: string | undefined) => {
    return date ? new Date(date) : undefined;
  };

  const getDefaultInstant = (date: string | undefined): Instant | undefined => {
    return date ? (new Date(date)).toInstant() : undefined;
  }

  const [from, setFromState] = useState<Date | undefined>(getDefaultDate(ctx.from));
  const [to, setToState] = useState<Date | undefined>(getDefaultDate(ctx.to));
  const [fromInstant, setFromInstant] = useState<Instant | undefined>(getDefaultInstant(ctx.from));
  const [toInstant, setToInstant] = useState<Instant | undefined>(getDefaultInstant(ctx.to));

  const [config, setConfig] = useState<any | undefined>(ctx?.config);
  const [ctxInit] = useState<TimeContext | undefined>(ctx);


  const applyReferenceTime = (time?: Date | string, cfg?: any) => {
    if (ctxInit?.from && ctxInit.to) {
      return;
    }
    applyTimeOptions(time ? new Date(time) : new Date(), cfg ?? config);
    if (cfg) {
      setConfig(cfg);
    }
  };

  const applyTimeOptions = (refTime: Date, cfg: any) => {
    const { from: tFrom, to: tTo } = getTimeRange(refTime, cfg);
    if (
      new Date(tFrom).getTime() !== from?.getTime() ||
      new Date(tTo).getTime() !== to?.getTime()
    ) {
      setFrom(tFrom || from);
      setTo(tTo || to);
    }
  };

  const setFrom = (date: Date | string) => {
    const d = new Date(date);
    setFromState(d);
    setFromInstant(d.toInstant())
  };

  const setTo = (date: Date | string) => {
    const d = new Date(date);
    setToState(d);
    setToInstant(d.toInstant)
  };

  return {
    applyReferneceTime: applyReferenceTime,
    from,
    fromInstant,
    setFrom,
    to,
    toInstant,
    setTo,
  };
}

const getTimeRange = (referenceTime: Date, config: any) => {
  const validatedConfig = config ? timeConfigValidation(config) : timeConfigValidation({});

  const startingDate = referenceTime ? new Date(referenceTime) : new Date();
  const tempDate = truncateDate(startingDate, config?.alignStartTo);

  const tempFrom = addToDate(
    tempDate,
    validatedConfig.startOffset,
    validatedConfig.startOffsetUnits
  );
  const tempTo = addToDate(tempFrom, validatedConfig.leadOffset, validatedConfig.leadUnits);

  const from = addToDate(tempFrom, validatedConfig.lagOffset * -1, validatedConfig.lagUnits);
  return swapDates(from, tempTo);
};

export default useTimeState;
